var app = angular.module("leonardo");

var ReportsOnDemandList = function($scope, $controller, $filter, $q, ReportService, FilterService, AttachmentService) {

  $controller('ReportsBaseController', { $scope: $scope });

  $scope.title = $filter('translate')('On Demand Instruction Reports');

  $scope.report_type = ReportService.TYPE_ON_DEMAND_INSTRUCTION;

  $scope.fieldsReport = ReportService.fieldsReportOnDemandInstruction;

  $scope.resetFields = function(){
    if (FilterService.hasFilter('fields_active')) {
      $scope.fields_active = FilterService.getFilter('fields_active').split(',');
    }
    else {
      $scope.fields_active = ['user_name', 'user_email', 'user_role','user_portfolios','user_properties', 'dates_access', 'last_access'];
    }

    if (FilterService.getFilter('group_by') === 'account') {
      if (!_.contains($scope.fields_active, 'property')) {
        $scope.fields_active.unshift('property');
      }
      if (!_.contains($scope.fields_active, 'portfolio')) {
        $scope.fields_active.unshift('portfolio');
      }
    }
    if ((FilterService.getFilter('group_by') === 'portfolio') || FilterService.getFilter('group_by') === 'group') {
      if (!_.contains($scope.fields, 'property')) {
        $scope.fields_active.unshift('property');
      }
    }
  };
  
  $scope.getAttachmentChange = function (id){
    var defer = $q.defer();
    AttachmentService.get(parseInt(id,10)).then(function(data){
       var result = data.link ? data.link : data.file;
       defer.resolve(result);
    });
    return defer.promise; 
  };

  $scope.getFieldValue = function(report, field) {
    var html = '';
    switch(field) {
      case 'user_name':
        return $filter('username')(report.account_user.user);
      case 'user_email':
        return report.account_user.user.email;
      case 'user_role':
        return report.account_user ? report.account_user.role.name : '-';
      case 'user_portfolios':
        html = '<div class="wrapper-portfolios-multi" read-more>';
        if (report.account_user.portfolios) {
          angular.forEach(report.account_user.portfolios, function(portfolio){
            html += '<span class="inline">' + portfolio.name + '</span>';
          });
        }
        html += '</div>';
        return html;
      case 'user_properties':
        html = '<div class="wrapper-properties-multi" read-more>';
        if (report.account_user.properties) {
          angular.forEach(report.account_user.properties, function(property){
            html += '<span class="inline">' + property.name + '</span>';
          });
        }
        html += '</div>';
        return html;
      case 'user_groups':
        html = '<div class="wrapper-properties-multi" read-more>';
        if (report.account_user.groups) {
          angular.forEach(report.account_user.groups, function(group){
            html += '<span class="inline">' + group.name + '</span>';
          });
        }
        html += '</div>';
        return html;
      case 'dates_access':
        html = '<div class="wrapper-date-multi" read-more>';
        if (report.dates_access) {
          angular.forEach(report.dates_access, function(date){
            html += '<span class="date-multi">' + moment(date).format('MMM DD, YYYY') + '</span>';
          });
        }
        html += '</div>';
        return html;
      case 'last_access':
        if (report.last_date_access) {
          return moment(report.last_date_access).format('MMM DD, YYYY');
        }
        else {
          return '-';
        }
      default: return report[field];
    }
  };

  $scope.getFieldClasses = function(field){
    var classes = [];
    switch (field) {
      case 'user_name': classes.push('field-name');
        break;
      case 'dates_access':
      case 'last_date_access':
        classes.push('date-multi-head');
        break;
    }
    return classes;
  };

  $scope.getChanges = function (fields) {
    var html = '<div class="wrapper-properties-multi" read-more>';
    angular.forEach(fields, function(value, key) {
      if(key==='attachments'){
        html += '<span class="inline bold">'+  key  + ':</span>';
        angular.forEach(value, function(id) {
          html += '<img src="'+ id +'">';
        });
      }
      else{
        html += '<span class="inline">'+ '<span class="inline bold">'+  key  + ':' +  '</span>'  + value + '</span>';
      }
    });
    html += '</div>';
    return html;
  };

  $scope.getIndexInstruction = function(on_demand_id, id) {
    var index = -1;
    angular.forEach($scope.reportsGrouped[$scope.getIndex(on_demand_id)].changes, function(value, key){
      if (value.id === id) {
        index = key;
      }
    });
    return index;
  };

  $scope.getIndexUserArray = function (array, id) {
    var index = -1;
    angular.forEach(array, function (value, key) {
      if (value.account_user.id === id) {
        index = key;
      }
    });
    return index;
  };

  $scope.groupReports = function(data) {
    if (data.results) {
      $scope.reports = data.results ? data.results : data;
      if (data.results.info_data) {
        $scope.info_data = data.results.info_data;
      }
    } else {
      $scope.reports = data;
    }

    $scope.reportsGrouped = [];

    var array_by_name = null;
    angular.forEach($scope.reports, function (value) {
      var id = 'ungroup';
      var name = null;
      switch (FilterService.getFilter('group_by')) {
        case 'account':
          if (value.account) {
            id = value.account.id;
            name = value.account.name;
          }
          array_by_name = $scope.accounts_by_name;
          break;
        case 'portfolio':
          if (value.account_user && value.account_user.portfolios) {
            id = [];
            name = [];
            angular.forEach(value.account_user.portfolios, function (portfolio) {
              id.push(portfolio.id);
              name.push(portfolio.name);
            });
          }
          array_by_name = $scope.portfolios_by_name;
          break;
        case 'property':
          if (value.account_user && value.account_user.properties) {
            id = [];
            name = [];
            angular.forEach(value.account_user.properties, function (property) {
              id.push(property.id);
              name.push(property.name);
            });
          }
          array_by_name = $scope.properties_by_name;
          break;
        case 'user_role':
          if (value.account_user) {
            id = value.account_user.role.id;
            name = value.account_user.role.name;
            array_by_name = [{id: id, name: name}];
          }
          break;
        default:
            if (value.on_demand_instruction) {
              id = value.on_demand_instruction.id;
              name = value.on_demand_instruction.name;
              array_by_name = [{id: id, name: name}];
            }
          break;
      }
      if (angular.isArray(id)) {
        angular.forEach(array_by_name, function (value_manager) {
          if ($scope.getIndex(value_manager.id) < 0) {
            $scope.reportsGrouped.push({id: value_manager.id, name: value_manager.name, reports: [], changes: []});
          }
          angular.forEach(value.changes, function(change){
            if(change.fields_modified.attachments){
              updateAttachment(change);
            }
            change.author = value.account_user.user;
            if ($scope.getIndexInstruction(value_manager.id, change.id) < 0) {
              $scope.reportsGrouped[$scope.getIndex(value_manager.id)].changes.push(change);
            }
          });

          if ($scope.getIndexUserArray($scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports, value.account_user.id) === -1) {
            $scope.reportsGrouped[$scope.getIndex(value_manager.id)].reports.push(value);
          }
        });
      }
      else {
        if ($scope.getIndex(id) < 0) {
          $scope.reportsGrouped.push({id: id, name: name, reports: [], changes: []});
        }
        angular.forEach(value.changes, function(change){
          if (change.fields_modified.attachments) {
            updateAttachment(change);
          }        
          change.author = value.account_user.user;
          if ($scope.getIndexInstruction(id, change.id) < 0) {
            $scope.reportsGrouped[$scope.getIndex(id)].changes.push(change);
          }
        });

        if ($scope.getIndexUserArray($scope.reportsGrouped[$scope.getIndex(id)].reports, value.account_user.id) === -1) {
          $scope.reportsGrouped[$scope.getIndex(id)].reports.push(value);
        }
      }

    });
    if ($scope.reportsGrouped.length === 1) {
      $scope.groupExpanded = $scope.reportsGrouped[0].id;
    }
  };

  function updateAttachment(change) {
    angular.forEach(change.fields_modified.attachments, function (attachment) {
      var index = change.fields_modified.attachments.indexOf(attachment);
      $scope.getAttachmentChange(attachment).then(function (resp) {
        change.fields_modified.attachments[index] = resp;
      });
    });
  }

};

app.controller('ReportsOnDemandList', ['$scope', '$controller', '$filter', '$q', 'ReportService', 'FilterService',
  'AttachmentService', ReportsOnDemandList]);
